import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import SimpleSelect from 'reusable/Select';
import SimpleText from 'reusable/Text';
import { usePodListQuery } from 'services/api';
import {
  useFetchRemotePodMappingQuery,
  useUpdateRemotePodMappingMutation,
} from 'services/api/remoteLayout';
import { track } from 'analytics/posthog';

function LinkModal({ show, name, onHide }) {
  const [pods, setPods] = useState<string[]>([]);
  const {
    data: mappings = [],
    isSuccess,
    isError,
    isLoading,
    isFetching,
    error,
  } = useFetchRemotePodMappingQuery(null);
  const {
    data: podList = [],
    isLoading: isPodListLoading,
    isError: isPodListError,
    error: podListError,
  } = usePodListQuery();

  const [updateMapping, updateMappingState] =
    useUpdateRemotePodMappingMutation();

  useEffect(() => {
    setPods(
      mappings.filter(map => map.remoteLayout === name).map(map => map.pod),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, show, isSuccess]);

  useEffect(() => {
    if (updateMappingState.isSuccess) {
      track('remote layout linked', {
        layout_name: name,
        pod_count: pods.length,
      });
      toast.success('Mappings updated Successfully');
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateMappingState.isSuccess]);

  useEffect(() => {
    if (isError) toast.error(get(error, 'data.error'));
    if (isPodListError) toast.error(get(podListError, 'data.error'));
    if (updateMappingState.isError)
      toast.error(get(updateMappingState, 'error,data.error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, isPodListError, updateMappingState.isError]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Remote Layout - Pod Linking</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading || isFetching ? (
          <Spinner animation="border" />
        ) : (
          <>
            <SimpleText label="Remote Layout" value={name} disabled />
            <SimpleSelect
              label="Pods"
              value={pods}
              onChange={setPods}
              options={podList.map(pod => pod.name)}
              isLoading={isPodListLoading}
              isMulti
              isCreateable
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => updateMapping({ pods, remoteLayout: name })}
          disabled={updateMappingState.isLoading}
        >
          Save
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LinkModal;
